import { render, staticRenderFns } from "./PhotoMultipleFacesModal.vue?vue&type=template&id=1916d204"
import script from "./PhotoMultipleFacesModal.vue?vue&type=script&lang=js"
export * from "./PhotoMultipleFacesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports